export const Directions = Object.seal({
	DOWN: 'down',
	LEFT: 'left',
	RIGHT: 'right',
	UP: 'up',
});
